// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__QBeGF","alertIcon":"ConfirmModal_alertIcon__1RqcZ"};